module.exports = __webpack_public_path__ + "static/media/bruno-dalto.5907f4e7.jpg";